export const ONLINE_APPOINTMENT_MESSAGE_MODES = {
  PUBLIC: '0',
  CUSTOM: '1',
}

export const ONLINE_APPOINTMENT_TEMPLATE_KEYS = {
  SUBMITTED: 'online_appointment_submitted',
  CONFIRMED: 'online_appointment_confirmed',
  FAILED: 'online_appointment_failed',
}

export const MAX_ONLINE_APPOINTMENT_MESSAGE_CHARACTERS = 280

export const ONLINE_APPOINTMENT_MESSAGE_TEMPLATES = [
  {
    key: ONLINE_APPOINTMENT_TEMPLATE_KEYS.SUBMITTED,
    title: '線上預約送出通知',
    requiredHint: '必須包含「診所名稱」',
    defaultContent: '#patient_name#您好，線上預約已送出，未獲確認嚴禁前往！點此看#clinic_name#預約規範 #appointment_url#',
  },
  {
    key: ONLINE_APPOINTMENT_TEMPLATE_KEYS.CONFIRMED,
    title: '線上預約成功通知',
    requiredHint: '必須包含「診所名稱」與「預約時間」',
    defaultContent: '#patient_name#，您的線上預約已被確認，請於#appointment_time#準時前往，若有疑問可致電#clinic_name#',
  },
  {
    key: ONLINE_APPOINTMENT_TEMPLATE_KEYS.FAILED,
    title: '線上預約不成功通知',
    requiredHint: '必須包含「診所名稱」與「預約時間」',
    defaultContent: '#patient_name#您好，您的線上預約 #appointment_time# 不成功，請致電#clinic_name#改約',
  },
]

export const ONLINE_APPOINTMENT_TOKEN_LABELS = {
  '#patient_name#': '病患姓名',
  '#clinic_name#': '診所名稱',
  '#appointment_url#': '預約明細',
  '#appointment_time#': '預約時間',
  '#clinic_phone#': '診所電話',
  '#appointments_notify_note#': '舊客製化備註',
}

export const ONLINE_APPOINTMENT_TOKEN_PREVIEW_VALUES = {
  '#patient_name#': '王小明',
  '#clinic_name#': '品橘牙醫診所',
  '#appointment_url#': 'https://link.dentco.tw/5d043469',
  '#appointment_time#': '2026/06/05 14:30',
  '#clinic_phone#': '(02)23631646',
  '#appointments_notify_note#': '',
}

export function getOnlineAppointmentTokenLabel(token) {
  return ONLINE_APPOINTMENT_TOKEN_LABELS[token] || token
}

export function calculateOnlineAppointmentSmsSegments(length) {
  return Math.max(Math.ceil(Number(length || 0) / 70), 1)
}

export function renderOnlineAppointmentMessagePreview(content, clinicName) {
  const values = {
    ...ONLINE_APPOINTMENT_TOKEN_PREVIEW_VALUES,
    '#clinic_name#': clinicName || ONLINE_APPOINTMENT_TOKEN_PREVIEW_VALUES['#clinic_name#'],
  }

  return Object.keys(values).reduce((message, token) => {
    return message.split(token).join(values[token])
  }, content || '')
}
